module.exports = __webpack_public_path__ + "media/images/icon-user-58e1a859330dfae0ef8a6ee0e0f6e64e.svg";